/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * @file OnboardingActionCard.jsx
 * Clickable onboarding action card (setup option).
 * @author Anuja Gaikwad
 * @since 2.0.0
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Icon from '../icons/Icon';
import { classes } from './styles/OnboardingSplashStyles';

const OnboardingActionCard = ({
  actionId,
  title,
  description,
  iconName,
  badgeLabel,
  onClick
}) => {
  const handleClick = () => {
    onClick?.(actionId);
  };

  const renderBadge = () => {
    if (!badgeLabel) {
      return null;
    }

    return <span className={classes.badge}>{badgeLabel}</span>;
  };

  return (
    <button
      type="button"
      className={classes.actionCard}
      onClick={handleClick}
      aria-label={title}
    >
      <div className={classes.actionCardIconWrap}>
        <Icon name={iconName} />
      </div>
      <div className={classes.actionCardBody}>
        <div className={classes.actionCardTitleRow}>
          <Typography component="h3" className={classes.actionCardTitle}>
            {title}
          </Typography>
          {renderBadge()}
        </div>
        <Typography component="p" className={classes.actionCardDescription}>
          {description}
        </Typography>
      </div>
    </button>
  );
};

OnboardingActionCard.propTypes = {
  actionId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  badgeLabel: PropTypes.string,
  onClick: PropTypes.func
};

OnboardingActionCard.defaultProps = {
  badgeLabel: '',
  onClick: () => {}
};

export default OnboardingActionCard;
